import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X, UserPlus, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// One-time popup on a member's SECOND distinct day in the app, nudging them to
// invite friends. Dismissed permanently via either button (dismissTip persists
// to user.dismissed_tips). Self-gates on visit_count so it never nags.
export const InviteNudge = () => {
  const { user, dismissTip } = useAuth();
  const navigate = useNavigate();
  const key = "invite-nudge@1";
  const dismissed = (user?.dismissed_tips || []).includes(key);
  const [closing, setClosing] = useState(false);

  if (!user || (user.visit_count || 0) !== 2 || dismissed || closing) return null;

  const notNow = () => { setClosing(true); dismissTip("invite-nudge", 1); };
  const go = () => { setClosing(true); dismissTip("invite-nudge", 1); navigate(`/profile/${user.id}?focus=resonance`); };

  return (
    <div className="fixed inset-0 z-[65] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-testid="invite-nudge-modal">
      <div className="relative bg-[#121212] border border-[#14A89A]/30 w-full max-w-md p-7 fade-up">
        <button onClick={notNow} aria-label="Close" data-testid="invite-nudge-close" className="absolute top-3.5 right-3.5 text-zinc-500 hover:text-white transition-colors"><X size={18} /></button>
        <div className="w-11 h-11 flex items-center justify-center bg-[#14A89A]/12 text-[#14A89A] mb-5"><Sparkles size={22} /></div>
        <h3 className="font-heading text-xl text-white mb-3">Invite your friends</h3>
        <p className="font-body text-sm text-zinc-300 leading-relaxed mb-7">If Sovereign Signal is lighting you up with visions of what's possible, invite your friends. Word of mouth is how this community grows.</p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button onClick={notNow} data-testid="invite-nudge-not-now" className="flex-1 border border-white/15 text-zinc-300 font-medium px-5 py-3 hover:bg-white/5 transition-colors font-body text-sm">Not now</button>
          <button onClick={go} data-testid="invite-nudge-go" className="flex-1 bg-[#14A89A] text-[#0A0A0A] font-medium px-5 py-3 hover:bg-[#2BC4B5] transition-colors font-body text-sm flex items-center justify-center gap-2"><UserPlus size={16} /> Invite my friends</button>
        </div>
      </div>
    </div>
  );
};
